import React from 'react';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import EnlargableTextbox from 'components/common/EnlargableTextbox';
import { toast } from 'react-toastify';
import { clientDetailAPI, clientDetailsAction, clientDetailsErrorAction, clientListAPI, getClientCnrDetailAPI } from 'actions/ClientRegistration/ClientRegistrationAction';
import FalconComponentCard from 'components/common/FalconComponentCard';
import { advocateClientCaseDataAction, advocateClientCaseErrorAction } from 'actions/AdvocateClientCase/AdvocateClientCaseAction';
import { caseTypeMasterListAPI } from 'actions/CaseTypeMaster/caseTypeMasterAction';
import { courtMasterListAPI } from 'actions/CourtMaster/courtMasterAction';
import { stateListAPI } from 'actions/StateMaster/stateMasterAction';
import { countryListAPI } from 'actions/CountryMaster/countryMasterAction';
import { formChangedAction } from 'actions';
import { getCourtTypeMasterListAPI } from 'actions/CourtTypeMaster/courtTypeMasterAction';
import loader from '../../assets/img/loader.svg'

export const AdvocateClientCaseDetail = () => {
  const dispatch = useDispatch();
  const [formHasError, setFormError] = useState(false);
  const [cnrError, setCNRError] = useState({});
  const [clientList, setClientList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [caseTypeList, setCaseTypeList] = useState([]);
  const [courtTypeList, setCourtTypeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalCNRShow, setCNRModalShow] = useState(false);
  const [showCourtDropdown, setShowCourtDropdown] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [courtMasterList, setCourtMasterList] = useState([]);
  const selectedClientCode = localStorage.getItem('ClientCode')
  const selectedCaseId = localStorage.getItem('EncryptedResponseCaseId')
  const [perPage, setPerPage] = useState(15);
  var clientStatus = localStorage.getItem('ClientStatus');
  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  let oldCaseStatus = localStorage.getItem("OldCaseStatus");

  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };

  const resetAdvocateClientCaseData = () => {
    dispatch(advocateClientCaseDataAction({
      'encryptedCaseId': '',
      'clientName': '',
      'clientCode': '',
      'clientType': '',
      'mobileNo': '',
      'contactPerson': '',
      'emailId': '',
      'clientCaseNo': '',
      'countryCode': '',
      'country': '',
      'stateCode': '',
      'state': '',
      'courtName': '',
      'judgeName': '',
      'consultingFees': '',
      'oppAdvName': '',
      'caseTitle': '',
      'policeStation': '',
      'firNo': '',
      'firDate': '',
      'caseNature': '',
      'caseCode': '',
      'oppAdvMob': '',
      'party': '',
      'caseRegisterDate': '',
      'nextHearingDate': '',
      'caseStatus': '',
      'attendantAdvocateName': '',
      'underSection': '',
      'fileDescription': '',
      'purpose': '',
      'fileNo': '',
      'roomNo': '',
      'almirah': '',
      'rack': '',
      'caseRecordNo': '',
    })
    );
    setStateList([])
    setCourtMasterList([])
  };

  const resetClientData = () => {
    dispatch(
      clientDetailsAction({
        'clientName': '',
        'encryptedAdvocateCode': '',
        'encryptedClientCode': '',
        'clientAddress1': '',
        'clientAddress2': '',
        'clientAddress3': '',
        'pinCode': '',
        'mobileNo': '',
        'emailId': '',
        'contactPerson': '',
        'countryCode': '',
        'country': '',
        'stateCode': '',
        'state': '',
        'landLineOffice': '',
        'landLineNo': '',
        'clientType': '',
        'occupation': '',
        'sendMail': '',
        'sendSMS': '',
        'sendWhatsapp': '',
      })
    );
  };

  const advocateClientCaseReducer = useSelector(
    state => state.rootReducer.advocateClientCaseReducer
  );
  var advocateClientCaseData = advocateClientCaseReducer.advocateClientCaseData
  const clientDetailReducer = useSelector(
    state => state.rootReducer.clientRegistrationReducer
  );
  var clientData = clientDetailReducer.clientData;
  if (!advocateClientCaseReducer.advocateClientCaseData ||
    Object.keys(advocateClientCaseReducer.advocateClientCaseData).length <= 0) {
    resetAdvocateClientCaseData();
  }

  if (
    !clientDetailReducer.clientData ||
    Object.keys(clientDetailReducer.clientData).length <= 0
  ) {
    resetClientData();
  }

  const clientDetailsErrorReducer = useSelector(
    state => state.rootReducer.clientDetailsErrorReducer
  );
  const clientError = clientDetailsErrorReducer.clientDetailsError;

  const advocateClientCaseDetailsErrorReducer = useSelector(
    state => state.rootReducer.advocateClientCaseDetailsErrorReducer
  );
  const caseDetailError = advocateClientCaseDetailsErrorReducer.advocateClientCaseDetailsError;

  const formChangedReducer = useSelector((state) => state.rootReducer.formChangedReducer)
  var formChangedData = formChangedReducer.formChanged;

  useEffect(() => {
    if (clientData.clientCode || selectedClientCode) {
      getClientDetail(clientData.clientCode || selectedClientCode)
      $('#txtClientCode').val(clientData.clientCode || selectedClientCode)
    
      dispatch(
      clientDetailsAction({
        ...clientData,
        clientType: selectedClientCode ? "existingClient" : "existingClient"
      })
    );
  
    } else {
      localStorage.removeItem("ClientCode")
      dispatch(advocateClientCaseDataAction({
        ...advocateClientCaseData,
        clientCode: '',
        clientName: '',
        emailId: '',
        contactPerson: '',
        mobileNo: '',
        // clientType: ''
      }));
           dispatch(clientDetailsAction({
        ...clientData,
        clientCode: '',
        clientName: '',
        emailId: '',
        contactPerson: '',
        mobileNo: '',
        // clientType: ''
      }));
    }
    
// if(selectedClientCode){
//       dispatch(
//       clientDetailsAction({
//         ...clientData,
//         clientType: selectedClientCode && "existingClient" 
//       })
//     );
//   }
  }, [selectedClientCode, clientData.clientCode])


  useEffect(() => {
    getCountries()
    getClientList(1)
    getCaseTypeMaster()

  }, []);

  useEffect(() => {
    if (advocateClientCaseData && advocateClientCaseData.stateCode && !$('#txtState').val()) {
      getStates(advocateClientCaseData.countryCode)
    }
    if (clientData && clientData.stateCode && !$('#txtState').val()) {
      getStates(clientData.countryCode)
    }
    if (advocateClientCaseData.stateCode &&
      !$('#txtCourtCode').val()) {
      getCourtMasterList(advocateClientCaseData.stateCode);
    }

  }, [advocateClientCaseData]);

  useEffect(() => {

    if (clientData && clientData.stateCode && !$('#txtState').val()) {
      getStates(clientData.countryCode)
    }

  }, [clientData]);

  useEffect(() => {

    if (selectedCaseId) {
      localStorage.setItem("ClientStatus", "ExitingClient")
    }

          if(selectedCaseId){
                      dispatch(
              advocateClientCaseDataAction({
                ...advocateClientCaseData,
                cRNo: selectedCaseId ? advocateClientCaseData.caseRecordNo : "",

              })
            );
                $('#textCrno').attr('disabled', true)
          }else{
$('#textCrno').attr('disabled', false)
          }
        
  }, [selectedCaseId]);

  useEffect(() => {
    getCourtTypeList();

  }, []);

  useEffect(() => {
    if (!advocateClientCaseData.countryCode && countryList.length > 0) {
      const indiaOption = countryList.find(c => c.key.toLowerCase() === 'india');
      if (indiaOption) {
        dispatch(
          advocateClientCaseDataAction({
            ...advocateClientCaseData,
            countryCode: indiaOption.value
          })
        );
        getStates(indiaOption.value)
      }
    }
    dispatch(
      clientDetailsAction({
        ...clientData,
        clientType: "existingClient"
      })
    );
  }, [countryList, advocateClientCaseData.countryCode]);

  useEffect(() => {
    if (!clientData.countryCode && !clientData.countryCode && countryList.length > 0) {
      const indiaOption = countryList.find(c => c.key.toLowerCase() === 'india');
      if (indiaOption) {
        dispatch(
          clientDetailsAction({
            ...clientData,
            countryCodeOffender: indiaOption.value,
            countryCodeDefender: indiaOption.value,
            countryCode: indiaOption.value,
             clientType: selectedClientCode ? "existingClient" : "existingClient"
          })
        );
        getStates(indiaOption.value)
      }
    }


  }, [countryList, clientData.countryCode]);

  useEffect(() => {
    if (selectedCaseId) {
      $('#textCaseRecordNo').attr('disabled', true)
      $('#textCaseYear').attr('disabled', true)
      $('#GetDetailBtn').attr('disabled', true)
      $('#resetBtn').attr('disabled', true)

      $('#clientOffender').attr('disabled', true)
      $('#clientDefender').attr('disabled', true)

    }else{
      $('#textCaseRecordNo').attr('disabled', false)
      $('#textCaseYear').attr('disabled', false)
      $('#GetDetailBtn').attr('disabled', false)
      $('#resetBtn').attr('disabled', false)

      $('#clientOffender').attr('disabled', false)
      $('#clientDefender').attr('disabled', false)

    }

  }, [selectedCaseId]);

  // useEffect(() => {
  //   if(clientData.clientType == "existingClient")
  //   dispatch(
  //     clientDetailsAction({
  //       ...clientData,
  //       clientType: "existingClient"
  //     })
  //   );
  // }, [clientData.clientType]);
  // useEffect(() => {


  // }, [clientData.clientCode]);

  const getCountries = async (page, size = perPage) => {
    const data = {
      pageNumber: page,
      pageSize: size,
      SearchText: '',
      isDropDown: true,
    };
    dispatch(
      countryListAPI(
        data,
        res => {
          let countryData = [];
          if (res.data.data.countryList.length > 0)
            res.data.data.countryList.forEach(country => {
              countryData.push({
                key: country.countryName,
                value: country.countryCode
              });
            });
          setCountryList(countryData);
        },
        err => {
          toast.error(err?.data?.message || 'Error fetching countries', {
            theme: 'colored',
            autoClose: 10000
          });
          setCountryList([]);
        },
        headers
      )
    );
  };

  const getStates = async (selectCountryCode) => {
    const data = {
      countryCode: selectCountryCode,
      isDropDown: true,
      isList: false
    }
    await dispatch(stateListAPI(
      data,
      res => {

        let stateData = [];
        if (res && res.length > 0) {
          res.forEach(state => {
            stateData.push({
              key: state.stateName,
              value: state.stateCode
            });
          });
          setStateList(stateData);
        } else {
          setStateList([]);
        }
      },
      (err) => {
        setStateList([]);
      }
    ));
  };

  const getCourtMasterList = async (selectStateCode) => {
    const data = {
      stateCode: selectStateCode,
      courtTypeCode: localStorage.getItem("CourtMasterType")
    }
    await dispatch(courtMasterListAPI(
      data,
      res => {
        let courtData = [];
        if (res.data && res.data.data.courtList.length > 0) {
          res.data.data.courtList.forEach(data => {
            courtData.push({
              key: data.courtName,
              value: data.courtCode
            });
          });
          setCourtMasterList(courtData);
        } else {
          setCourtMasterList([]);
        }
      },
      (err) => {
        setCourtMasterList([]);
      },
      headers
    ));
  };

  const getClientList = async () => {
    const data = {
      pageNumber: 1,
      pageSize: 1,
      SearchText: '',
      EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
      isDropDown: true
    };
    await dispatch(
      clientListAPI(
        data,
        res => {
          let clientData = [];

          if (res.data.data.clientList.length > 0)
            res.data.data.clientList.forEach(client => {
              clientData.push({
                key: client.clientName,
                value: client.clientCode
              });
            });
          setClientList(clientData);
          console.log(clientData)
        },
        err => {
          setClientList([]);
          console.log(err?.data.message);
        },
        headers
      )
    );
  };

  const getCourtTypeList = (page, size = perPage) => {
    const data = {
      isDropdown: true
    };
    dispatch(
      getCourtTypeMasterListAPI(
        data,
        res => {
          let courtTypeData = [];
          if (res.data.data.courtTypeMasterList.length > 0)
            res.data.data.courtTypeMasterList.forEach(courtType => {
              courtTypeData.push({
                key: courtType.courtTypeName,
                value: courtType.courtTypeCode
              });
            });
          setCourtTypeList(courtTypeData);
        },
        err => {
          toast.error(err?.data?.message || 'Error fetching court types list', {
            theme: 'colored',
            autoClose: 10000
          });
          setCourtTypeList([]);
        },
        headers
      )
    );
  };

  const getClientDetail = async (ClientCode) => {
    var request = {
      ClientCode: ClientCode
    }
    setIsLoading(true);
    await dispatch(
      clientDetailAPI(
        request,
        res => {
          setIsLoading(false)
          var clientDetail = res.data.data.clientDetail
          dispatch(clientDetailsAction({
            ...clientData,
            clientName: clientDetail.client_Name,
            emailId: clientDetail.eMail_Id,
            mobileNo: clientDetail.mobile_No,
            ...clientDetail,
            clientCode: clientDetail.client_Code,
            stateCode: clientDetail.state_Code,
            countryCode: clientDetail.country_Code,
             clientType: "existingClient"

          }));

          if(advocateClientCaseData.caseRecordNo){
                      dispatch(
              advocateClientCaseDataAction({
                ...advocateClientCaseData,
                cRNo:  advocateClientCaseData.caseRecordNo || "",

              })
            );
                $('#textCrno').attr('disabled', true)
          }
        },
        err => {
          setIsLoading(false)
          toast.error(err?.data?.message || 'Error fetching client', {
            theme: 'colored',
            autoClose: 10000
          });
          dispatch(advocateClientCaseDataAction(undefined));
          dispatch(clientDetailsAction(undefined));
        },
        headers
      )
    );
  };

  const getCaseTypeMaster = async () => {
    const data = {
      isDropDown: true
    }
    await dispatch(
      caseTypeMasterListAPI(
        data,
        res => {
          let listData = [];
          if (res.data.data.caseTypeMasterList.length > 0)
            res.data.data.caseTypeMasterList.forEach(data => {
              listData.push({
                key: data.caseType,
                value: data.caseCode
              });
            });
          setCaseTypeList(listData);
        },
        err => {
          toast.error(err?.data?.message || 'Error fetching case type list', {
            theme: 'colored',
            autoClose: 10000
          });
          setCaseTypeList([]);
        },
        headers
      )
    );
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (name == "courtType") {
      const selectedCourt = e.target.options[e.target.selectedIndex].text;
      localStorage.setItem("CourtMasterTypeName", selectedCourt);
      localStorage.setItem("CourtMasterType", e.target.value);
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          courtType: e.target.value
        })
      );

    }
    // if (oldCaseStatus === "DISPOSED") {
    //   return;
    // }

    if (e.target.name == 'caseRecordNo') {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          caseRecordNo: e.target.value
        })
      );
    }
    if (e.target.name == 'diaryNumber') {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          diaryNumber: e.target.value
        })
      );
    }

    if (e.target.name == 'caseFilingYear') {
      const newYear = e.target.value;
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          caseFilingYear: newYear
        })
      );
    }

    if (clientStatus == "NewClient" && (advocateClientCaseData.respondentName || advocateClientCaseData.petitionerName)) {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          party: e.target.value
        })
      );
      setCNRModalShow(false)
    }

    if (e.target.name == "party" && e.target.value == 'Petitioner' && (advocateClientCaseData.respondentName || advocateClientCaseData.petitionerName)) {
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientName: advocateClientCaseData.petitionerName
        })
      );
    } if (e.target.name == "party" && e.target.value == 'Respondents' && (advocateClientCaseData.respondentName || advocateClientCaseData.petitionerName)) {
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientName: advocateClientCaseData.respondentName
        })
      );
    }
    if (e.target.name == 'clientCode') {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          clientCode: e.target.value
        })
      );
      if (e.target.value) {
        getClientDetail(e.target.value)
      } else {
        localStorage.removeItem("ClientCode")
        dispatch(advocateClientCaseDataAction({
          ...advocateClientCaseData,
          clientCode: '',
          clientName: '',
          emailId: '',
          eMail_Id: '',
          contactPerson: '',
          mobileNo: '',
          clientType: ''
        }));
      }
    }
    if (e.target.name == 'caseCode') {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          caseCode: e.target.value,
        }))
    }
    if (e.target.name == "countryCode") {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          countryCode: e.target.value,
          stateCode: null,
          courtCode: null
        }))
      setStateList([]);
      setCourtMasterList([])
      e.target.value && getStates(e.target.value);
    }
    else if (e.target.name == "stateCode") {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          stateCode: e.target.value,
          courtCode: null
        }))
      setCourtMasterList([])
      e.target.value && getCourtMasterList(e.target.value);
    }
    else {
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          [e.target.name]: e.target.value
        })
      );
    }
    if (advocateClientCaseData.encryptedCaseId || selectedCaseId) {
      dispatch(
        formChangedAction({
          ...formChangedData,
          AdvocateClientCaseUpdate: true
        })
      );
    } else {
      dispatch(
        formChangedAction({
          ...formChangedData,
          AdvocateClientCaseAdd: true
        })
      );
    }
  };

  const handleClientFieldChange = e => {
  
    if (e.target.name == 'clientName') {
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientCode: e.target.value,
        }))
      getClientDetail(e.target.value)
      localStorage.setItem("ClientCode",e.target.value)
    }
    else if (e.target.name == 'clientType' && e.target.value == "defender") {
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientType: e.target.value,
          emailId: "",
          emailIdOffender: "",
          // countryCode: "",
          // countryCodeOffender: "",
          stateCode: "",
          stateCodeOffender: "",
          clientCode: "",
          // offenderName: "",
          mobileNo: "",
          mobileNoOffender: ""
        })
      );
      
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          party: "Defender",
        })
      );
       dispatch(clientDetailsErrorAction(undefined));
    }
    else if (e.target.name == 'clientType' && e.target.value == "offender") {
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientType: e.target.value
        })
      );
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientType: e.target.value,
          emailId: "",
          emailIdDefender: "",
          // countryCode: "",
          // countryCodeDefender: "",
          stateCode: "",
          stateCodeDefender: "",
          clientCode: "",
          // defenderName: "",
          mobileNo: "",
          mobileNoDefender: ""
        })
      );
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          party: "Offender",
        })
      );
    dispatch(clientDetailsErrorAction(undefined));
    }
    else if (e.target.name == 'clientType' && e.target.value == "existingClient") {
      dispatch(
        clientDetailsAction({
          ...clientData,
          clientType: e.target.value
        })
      );
      // dispatch(
      //   clientDetailsAction({
      //     ...clientData,
      //     clientType: e.target.value,
      //     emailIdOffender: "",
      //     emailIdDefender: "",
      //     countryCodeOffender: "",
      //     countryCodeDefender: "",
      //     stateCodeOffender: "",
      //     stateCodeDefender: "",
      //     offenderName: "",
      //     defenderName: "",
      //     mobileNoOffender: "",
      //     mobileNoDefender: ""
      //   })
      // );
      dispatch(
        advocateClientCaseDataAction({
          ...advocateClientCaseData,
          party: "",
        })
      );
       dispatch(clientDetailsErrorAction(undefined));
    }
    else if (e.target.name == 'countryCodeOffender') {
      dispatch(
        clientDetailsAction({
          ...clientData,
          countryCodeOffender: e.target.value,
          stateCodeOffender: null
        })
      );
      setStateList([]);
      e.target.value && getStates(e.target.value);
    }
    else if (e.target.name == 'countryCodeDefender') {
      dispatch(
        clientDetailsAction({
          ...clientData,
          countryCodeDefender: e.target.value,
          stateCodeDefender: null
        })
      );
      setStateList([]);
      e.target.value && getStates(e.target.value);
    }
    else {
      dispatch(
        clientDetailsAction({
          ...clientData,
          [e.target.name]: e.target.value
        })
      );
    }


    if (clientData.encryptedClientCode) {
      dispatch(
        formChangedAction({
          ...formChangedData,
          clientUpdate: true
        })
      );
    } else {
      dispatch(
        formChangedAction({
          ...formChangedData,
          clientAdd: true
        })
      );
    }
  };
  // const cNRValidation = () => {
  //   const caseNumberRecErr = {};
  //   let isValid = true;

  //   if (!advocateClientCaseData.caseRecordNo) {
  //           //  toast.error("Please enter case record number", {
  //           //       theme: 'colored',
  //           //       autoClose: 10000
  //           //     });
  //      caseNumberRecErr.empty = "Please enter case record number";
  //     isValid = false;
  //   }
  //   if (!isValid) {
  //     var errorObject = {
  //       // caseNumberRecErr,
  //       setCNRError(caseNumberRecErr);
  //     };
  //     // dispatch(advocateClientCaseErrorAction(errorObject));
  //   }
  //   return isValid;
  // };

  const cNRValidation = () => {
    const caseNumberRecErr = {};
    let isValid = true;

    if (!advocateClientCaseData.caseRecordNo) {
      caseNumberRecErr.empty = "Please enter case number record";
      isValid = false;
    } else
      if (advocateClientCaseData.caseRecordNo && advocateClientCaseData.caseRecordNo.length !== 16) {
        caseNumberRecErr.empty = 'Case number record should have 16 long';
        isValid = false;
        setFormError(true);
      }

    if (!isValid) {
      setCNRError(caseNumberRecErr);
    }

    return isValid;
  };


  const handleGetCaseDetailChange = (value) => {
    if (value == "GetCaseDetail") {
      const isValid = cNRValidation();

      if (isValid && (advocateClientCaseData.caseRecordNo || (advocateClientCaseData.caseRecordNo && advocateClientCaseData.caseFilingYear))) {
        setCNRError({})
        getClientCnrDetail(advocateClientCaseData.caseRecordNo, advocateClientCaseData.caseFilingYear);
      }
    }
    if (value == "reset") {
      //            dispatch(
      //   advocateClientCaseDataAction({
      //     ...advocateClientCaseData,
      //     offenderName: "",
      //     defenderName: ""
      //   })
      // );
      $('#textCrno').attr('disabled', false);
      setCNRError({})
      dispatch(clientDetailsAction({}));
      dispatch(advocateClientCaseDataAction({}))
      dispatch(clientDetailsErrorAction(undefined));
      dispatch(advocateClientCaseErrorAction(undefined))
    }
  };

  const toInputDate = (dateString) => {
  if (!dateString) return '';
  // Remove Z to prevent timezone conversion
  const cleanDate = dateString.replace(/Z$/, '');
  const date = new Date(cleanDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


  const getClientCnrDetail = (cnr, caseFilingYear) => {
    const data = {
      encryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
      caseNumberRecord: cnr ? cnr : clientData.cnr,
      caseFilingYear: caseFilingYear ? caseFilingYear : advocateClientCaseData.caseFilingYear,
      diaryNumber: cnr ? cnr : advocateClientCaseData.cnr,
    };
    setIsLoading(true)
    dispatch(
      getClientCnrDetailAPI(
        data,
        res => {
          if (res.data.status == 200) {
            var clientDetail = JSON.parse(res.data.data.clientDetail);
            setIsLoading(false)
            if (clientStatus == "NewClient") {
              setCNRModalShow(true)
            }
          $('#textCrno').attr('disabled', true);
            dispatch(
              clientDetailsAction({
                ...clientData,
                offenderName: clientDetail.parties?.petitioners?.[0] || '',
                defenderName: clientDetail.parties?.respondents?.[0] || '',
                 clientType: "offender"
              })
            );
            dispatch(
              advocateClientCaseDataAction({
                ...advocateClientCaseData,
                cRNo: clientDetail.cnr || '',
                caseTitle: (clientDetail.title || '').slice(0, 250),
                clientCaseNo: clientDetail?.details?.registrationNumber || clientDetail?.registration?.number || '',
                filingNo: clientDetail?.details?.filingNumber || clientDetail?.filing?.number || '',
                filingDate:  toInputDate(clientDetail?.details?.filingDate)  || toInputDate(clientDetail?.filing?.date)  || '',
                registrationNumber: clientDetail.details?.registrationNumber || clientDetail.registration?.number || '',
                caseRegisterDate: toInputDate(clientDetail.details?.registrationDate) || toInputDate(clientDetail.registration?.date) || '',
                nextHearingDate: toInputDate(clientDetail.status?.nextHearingDate) || toInputDate(clientDetail.status?.nextHearingDate) || toInputDate(clientDetail.status?.nextDate) || '',
                petitionerName: clientDetail.parties?.petitioners?.[0] || '',
                respondentName: clientDetail.parties?.respondents?.[0] || '',
                petitionerAdvocate: clientDetail.parties?.petitionerAdvocates?.[0] || clientDetail.parties?.petitionerAdvocates?.[0] || '',
                respondentAdvocate: clientDetail.parties?.respondentAdvocates?.[0] || clientDetail.parties?.respondentAdvocates?.[0] || '',
                underSection: clientDetail.actsAndSections?.sections || clientDetail.acts?.[0]?.section || '',
                policeStation: clientDetail.firstInformationReport?.policeStation || '',
                firNo: clientDetail.firstInformationReport?.firNumber || '',
                firYear: clientDetail.firstInformationReport?.year || '',
                judgeName: clientDetail.history?.[0]?.judge || '',

              })
            );
          }
        },
        err => {
          console.log(err?.data?.message)
          toast.error('Data not found!', {
            theme: 'colored',
            autoClose: 10000
          });
          setIsLoading(false)
              $('#textCrno').attr('disabled', false);
          dispatch(
            advocateClientCaseDataAction({
              ...advocateClientCaseData,
              caseRecordNo: advocateClientCaseData.caseRecordNo || '',
              cRNo: "",
              caseTitle: '',
              clientCaseNo:'',
              registrationNumber: '',
              caseRegisterDate: '',
              nextHearingDate: '',
              petitionerName: '',
              respondentName: '',
              petitionerAdvocate: '',
              respondentAdvocate: '',
              underSection: '',
              policeStation: '',
              firNo: '',
              firYear: '',
              judgeName: '',
              filingDate: null,
              filingNo:''
            })
          );
                    dispatch(
              clientDetailsAction({
                ...clientData,
                defenderName : '',
                offenderName: ''
              })
            );
        },
        headers
      )
    );
  };

  const closeCNRModal = () => {
    setCNRModalShow(false);
  }

  return (
    <>
      {/* {isLoading ? (
        <Spinner
          className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          animation="border"
        />
      ) : null} */}
      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

      {modalCNRShow && (
        <Modal
          show={modalCNRShow}
          onHide={closeCNRModal}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Select Client
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
              <div style={{ textAlign: 'center' }}>
                <h5>Petitioner</h5>
                <Button
                  variant="outline-primary"
                  onClick={() =>
                    handleFieldChange({
                      target: {
                        name: 'party',
                        value: "Petitioner"
                      }
                    })
                  }
                >
                  {advocateClientCaseData.petitionerName || 'N/A'}
                </Button>
              </div>
              <div style={{ textAlign: 'center' }}>
                <h5>Respondent</h5>
                <Button
                  variant="outline-secondary"
                  onClick={() =>
                    handleFieldChange({
                      target: {
                        name: 'party',
                        value: "Respondents"
                      }
                    })
                  }
                >
                  {advocateClientCaseData.respondentName || 'N/A'}
                </Button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeCNRModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )}


      {advocateClientCaseData &&
        <Form noValidate validated={formHasError} className="case-reg-from" id='addAdvocateClientCaseDetailsForm'>
          <Row className="g-2 mb-2 row-content-pt5px">
            <Col sm={12} lg={12} className="no-pd-card">
              <FalconComponentCard className="farmer-card-row1 add-case-client-detail client-detail-popup cnr-section case-header-title">
                <FalconComponentCard.Header className='bg-green' title="Enter CNR/Diary No" light={false} />
                <FalconComponentCard.Body language="jsx">
                  <Row>
                    <Col className="" sm={4} md={4}>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon text-nowrap">
                          CNR No./Diary No. <span className="text-danger">*</span><span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="textCaseRecordNo"
                            maxLength={16}
                            name="caseRecordNo"
                            placeholder="CNR No/Diary No"
                            value={advocateClientCaseData?.caseRecordNo || ""}
                            onChange={handleFieldChange}
                            required
                          />
                          {cnrError.empty && <span className="error-message crnError-text">{cnrError.empty}</span>}
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col className="" sm={4} md={4}>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={1} className="label-with-colon">
                          Year <span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="textCaseYear"
                            maxLength="4"
                            name="caseFilingYear"
                            placeholder="Year"
                            onKeyPress={e => {
                              const regex = /[0-9]/;
                              const key = String.fromCharCode(e.charCode);
                              if (!regex.test(key)) {
                                e.preventDefault();
                              }
                            }}
                            value={advocateClientCaseData.caseFilingYear}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col className="" sm={4} md={4}>
                      <Col sm={12} className="d-flex justify-content-end">
                        <Button className="me-2" id='GetDetailBtn' onClick={() => handleGetCaseDetailChange("GetCaseDetail")}>Get Case Details</Button>
                        <Button className='btn-danger' id='resetBtn' onClick={() => handleGetCaseDetailChange("reset")}>Reset</Button>
                      </Col>
                    </Col>
                  </Row>
                </FalconComponentCard.Body>
              </FalconComponentCard>
            </Col>
            <Col sm={12} lg={12} className="no-pd-card">
              <FalconComponentCard className="farmer-card-row1 client-detail-section  client-detail-popup case-header-title">
                <FalconComponentCard.Header className='bg-green text-white' title="Select Offender/Defender/Existing Client" light={false} />
                <FalconComponentCard.Body language="jsx">
                  <Row>
                    <Col className="" sm={4} md={4}>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Check
                            type="checkbox"
                            id="sendWhatsAppChBox"
                            className="mb-1"
                          >
                            <Form.Check.Input
                              type="radio"
                              id='clientOffender'
                              label="Client is Offender"
                              name="clientType"
                              value="offender"
                              checked={clientData.clientType === 'offender'}
                              onChange={handleClientFieldChange}
                            />
                            <Form.Check.Label className="mb-0 checkboxDefeText d-inline-flex align-items-center gap-1 text-nowrap  ">
                              Client Is Offender
                            </Form.Check.Label>
                          </Form.Check>
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon defendersName">
                          Offender
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtOffenderName"
                            name="offenderName"
                            maxLength={100}
                            value={clientData.offenderName ? clientData.offenderName : ""}
                            onChange={handleClientFieldChange}
                            placeholder="Offender Name"
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "defender") ? true : false}
                            required
                          />
                          {Object.keys(clientError.offenderNameErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.offenderNameErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtCountryCodeOffender"
                            name="countryCodeOffender"
                            value={clientData.countryCodeOffender}
                            onChange={handleClientFieldChange}
                            required
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "defender") ? true : false}
                          >
                            <option value="">Select Country</option>
                            {countryList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(clientError.countryOffenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.countryOffenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>

                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtStateOffender"
                            name="stateCodeOffender"
                            value={clientData.stateCodeOffender}
                            onChange={handleClientFieldChange}
                            required
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "defender") ? true : false}
                          >
                            <option value="">Select State</option>
                            {stateList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(clientError.stateOffenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.stateOffenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtMobileNoOffender"
                            name="mobileNoOffender"
                            maxLength={10}
                            value={clientData.mobileNoOffender}
                            onChange={handleClientFieldChange}
                            placeholder="Mobile No."
                            onKeyPress={e => {
                              const regex = /[0-9]|\./;
                              const key = String.fromCharCode(e.charCode);
                              if (!regex.test(key)) {
                                e.preventDefault();
                              }
                            }}
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "defender") ? true : false}
                            required
                          />
                          {Object.keys(clientError.mobileNoOffenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.mobileNoOffenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtEmailOffender"
                            name="emailIdOffender"
                            maxLength={100}
                            value={clientData.emailIdOffender}
                            onChange={handleClientFieldChange}
                            placeholder="Email ID"
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "defender") ? true : false}
                            required
                          />
                          {Object.keys(clientError.emailOffenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.emailOffenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col className="" sm={4} md={4}>

                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Check
                            type="checkbox"
                            id="sendWhatsAppChBox"
                            className="mb-1"
                          >
                            <Form.Check.Input
                              type="radio"
                              id='clientDefender'
                              label="Client is Defender"
                              name="clientType"
                              value="defender"
                              checked={clientData.clientType === 'defender'}
                              onChange={handleClientFieldChange}
                            />
                            <Form.Check.Label className="mb-0 checkboxDefeText d-inline-flex align-items-center gap-1 text-nowrap ">
                              Client Is Defender
                            </Form.Check.Label>
                          </Form.Check>
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon defendersName ">
                          Defender Name
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtDefenderName"
                            name="defenderName"
                            maxLength={100}
                            value={clientData.defenderName ? clientData.defenderName : ""}
                            onChange={handleClientFieldChange}
                            placeholder="Defender Name"
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "offender") ? true : false}
                            required
                          />
                          {Object.keys(clientError.defenderNameErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.defenderNameErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtCountryDefender"
                            name="countryCodeDefender"
                            value={clientData.countryCodeDefender}
                            onChange={handleClientFieldChange}
                            required
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "offender") ? true : false}
                          >
                            <option value="">Select Country</option>
                            {countryList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(clientError.countryDefenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.countryDefenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtStateDefender"
                            name="stateCodeDefender"
                            value={clientData.stateCodeDefender}
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "offender") ? true : false}
                            onChange={handleClientFieldChange}
                            required
                          >
                            <option value="">Select State</option>
                            {stateList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(clientError.stateDefenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.stateDefenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtMobileNoDefender"
                            name="mobileNoDefender"
                            maxLength={10}
                            value={clientData.mobileNoDefender}
                            onChange={handleClientFieldChange}
                            placeholder="Mobile No."
                            onKeyPress={e => {
                              const regex = /[0-9]|\./;
                              const key = String.fromCharCode(e.charCode);
                              if (!regex.test(key)) {
                                e.preventDefault();
                              }
                            }}
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "offender") ? true : false}
                            required
                          />
                          {Object.keys(clientError.mobileNoDefenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.mobileNoDefenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtEmailDefender"
                            name="emailIdDefender"
                            maxLength={100}
                            value={clientData.emailIdDefender}
                            onChange={handleClientFieldChange}
                            placeholder="Email ID"
                            disabled={(clientData.clientType == "existingClient" || clientData.clientType == "offender") ? true : false}
                            required
                          />
                          {Object.keys(clientError.emailDefenderErr).map(key => {
                            return (
                              <span className="error-message">
                                {clientError.emailDefenderErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col className="" sm={4} md={4}>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Check
                            type="checkbox"
                            id="sendWhatsAppChBox"
                            className="mb-1"
                          >
                            <Form.Check.Input
                              type="radio"
                              id='existingClient'
                              label="Existing Client"
                              name="clientType"
                              value="existingClient"
                              checked={clientData.clientType === 'existingClient'}
                              onChange={handleClientFieldChange}
                            />
                            <Form.Check.Label className="mb-0 checkboxDefeText d-inline-flex align-items-center gap-1 text-nowrap ">
                              Existing Client
                            </Form.Check.Label>
                          </Form.Check>
                        </Col>
                      </Form.Group>
                      {selectedCaseId ? <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon defendersName existing-name">
                          Existing Client
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                               className='textExistingName'
                   id="txtClientName"
                            value={advocateClientCaseData.clientName ? advocateClientCaseData.clientName : clientData.clientName}
                            name="clientName"
                            placeholder="Client Name"
                            disabled
                          />

                        </Col>
                      </Form.Group> :  <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon defendersName existing-name">
                          Existing Client
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                          className='textExistingName'
                            id="txtClientCode"
                            name="clientCode"
                            maxLength={15}
                            disabled={(clientData.clientType == "defender" || clientData.clientType == "offender") ? true : false}
                            value={clientData?.clientCode || ""}
                            onChange={(e) => handleFieldChange(e)}
                          >
                            <option value="">Select </option>
                            {clientList?.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Form.Group> }
                      {/* <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon defendersName existing-name">
                          Existing Client
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                          className='textExistingName'
                            id="txtClientCode"
                            name="clientCode"
                            maxLength={15}
                            disabled={(clientData.clientType == "defender" || clientData.clientType == "offender") ? true : false}
                            value={clientData?.clientCode || ""}
                            onChange={(e) => handleFieldChange(e)}
                          >
                            <option value="">Select </option>
                            {clientList?.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Form.Group> */}
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtEmail"
                            name="emailId"
                            maxLength={100}
                            value={clientData.emailId ? clientData.emailId : ""}
                            onChange={handleClientFieldChange}
                            placeholder="Email"
                            disabled={(clientData.clientType == "defender" || clientData.clientType == "offender" || clientData.clientCode) ? true : false}
                            required
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtCountry"
                            name="countryCode"
                            value={clientData.countryCode}
                            onChange={handleClientFieldChange}
                            required
                            disabled={(clientData.clientType == "defender" || clientData.clientType == "offender" || clientData.clientCode) ? true : false}
                          >
                            <option value="">Select Country</option>
                            {countryList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtState"
                            name="stateCode"
                            value={clientData.stateCode}
                            onChange={handleClientFieldChange}
                            required
                            disabled={(clientData.clientType == "defender" || clientData.clientType == "offender" || clientData.clientCode) ? true : false}
                          >
                            <option value="">Select State</option>
                            {stateList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-1 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtMobileNo"
                            name="mobileNo"
                            maxLength={10}
                            value={clientData.mobileNo}
                            onChange={handleClientFieldChange}
                            placeholder="Mobile No."
                            onKeyPress={e => {
                              const regex = /[0-9]|\./;
                              const key = String.fromCharCode(e.charCode);
                              if (!regex.test(key)) {
                                e.preventDefault();
                              }
                            }}
                            disabled={(clientData.clientType == "defender" || clientData.clientType == "offender" || clientData.clientCode) ? true : false}
                            required
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtEmail"
                            name="emailId"
                            maxLength={100}
                            value={clientData.emailId}
                            onChange={handleClientFieldChange}
                            placeholder="Email ID"
                            disabled={(clientData.clientType == "defender" || clientData.clientType == "offender" || clientData.clientCode) ? true : false}
                            required
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </FalconComponentCard.Body>
              </FalconComponentCard>
            </Col>
          </Row>
          <Row className="g-0 mb-2 row-content-pt5px main-card">
            <Col sm={12} lg={12} className="no-pd-card">
              <FalconComponentCard className="farmer-card-row1 add-case-client-detail add-case-new  case-header-title">
                <FalconComponentCard.Header className='bg-green' title="Case Detail" light={false} />
                <FalconComponentCard.Body language="jsx">
                  <Row>
                    <Col className="me-3 ms-3" >
                      <Row className="mb-1">
                        <Form.Label>
                          CNR
                        </Form.Label>
                        <Form.Control
                          id="textCrno"
                          maxLength={16}
                          name="cRNo"
                          placeholder="Case Record No"
                          value={advocateClientCaseData?.cRNo}
                          onChange={handleFieldChange}
                        />
                        {Object.keys(caseDetailError?.cnrErr || {}).map(key => {
                          return (
                            <span key={key} className="error-message">
                              {caseDetailError.cnrErr[key]}
                            </span>
                          );
                        })}
                      </Row>
                    </Col>
                    <Col className="me-3 ms-3" >
                      <Row className="mb-1">
                        <Form.Label>
                          Case No.<span className="text-danger">*</span>
                        </Form.Label>
                        <EnlargableTextbox
                          id="txtCaseNo"
                          maxLength={30}
                          name="clientCaseNo"
                          placeholder="Case No"
                          value={advocateClientCaseData.clientCaseNo}
                          onChange={handleFieldChange}
                          required
                        />
                        {Object.keys(caseDetailError?.caseNoErr || {}).map(key => {
                          return (
                            <span key={key} className="error-message">
                              {caseDetailError.caseNoErr[key]}
                            </span>
                          );
                        })}
                      </Row>
                    </Col>
                    <Col className="me-3 ms-3" >
                      <Row className="mb-1">
                        <Form.Label>
                          Case Title<span className="text-danger">*</span>
                        </Form.Label>
                        <EnlargableTextbox
                          id="txtCaseTitle"
                          maxLength={255}
                          name="caseTitle"
                          placeholder="Case Title"
                          value={advocateClientCaseData.caseTitle}
                          onChange={handleFieldChange}
                        />
                        {Object.keys(caseDetailError?.caseTitleErr || {}).map(key => {
                          return (
                            <span key={key} className="error-message">
                              {caseDetailError.caseTitleErr[key]}
                            </span>
                          );
                        })}
                      </Row>
                    </Col>
                    <Col className="me-4 ms-3 "  >
                      <Row className="mb-1">
                        <Form.Label className=''>
                          Case Type<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          id="txtCaseType"
                          name="caseCode"
                          value={advocateClientCaseData.caseCode}
                          onChange={handleFieldChange}
                          required
                          className=' ms-1 '
                        >
                          <option value="">Select Case Type</option>
                          {caseTypeList.map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.key}
                            </option>
                          ))}
                        </Form.Select>
                        {Object.keys(caseDetailError?.caseTypeErr || {}).map(key => {
                          return (
                            <span key={key} className="error-message">
                              {caseDetailError.caseTypeErr[key]}
                            </span>
                          );
                        })}
                      </Row>
                    </Col>
                    <Col className="me-3 ms-3" >
                      <Row className="mb-1">
                        <Form.Label>
                          Case Nature
                        </Form.Label>
                        <Form.Select
                          id="txtCaseNature"
                          name="caseNature"
                          value={advocateClientCaseData.caseNature}
                          onChange={handleFieldChange}
                        >
                          <option value="">Select Case Nature</option>
                          <option value="CRIMINAL" selected>CRIMINAL</option>
                          <option value="CIVIL">CIVIL</option>
                          <option value="COMPANY MATTER">COMPANY MATTER</option>
                          <option value="CONSUMER COMPLAINT">CONSUMER COMPLAINT</option>
                          <option value="REVENUE">REVENUE</option>
                          <option value="SERVICE">SERVICE</option>
                          <option value="ARBITRATION">ARBITRATION</option>
                          <option value="TAXATION">TAXATION</option>
                        </Form.Select>
                      </Row>
                    </Col>
                    <Col className="ms-2 me-3" >
                      <Row className="mb-1">
                        <Form.Label>
                          Under Section</Form.Label>
                        <Form.Control
                          id="txtUnderSection"
                          name="underSection"
                          maxLength={30}
                          placeholder="Under Section"
                          value={advocateClientCaseData.underSection}
                          onChange={handleFieldChange}
                        />
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="second-case-popup" sm={4} md={4}>
                      <Row className="mb-1 mt-2 hidden-controler">

                        <Form.Control
                          className='mb-1 '
                          style={{ visibility: 'hidden' }}
                          disabled
                          placeholder="Hidden Field"
                        />

                      </Row>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1 fir-no-popup"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          FIR No.<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtFirNo"
                            maxLength={30}
                            name="firNo"
                            placeholder="FIR No"
                            value={advocateClientCaseData.firNo}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          FIR Date<span className='ms-3'>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control type='date' id="dtFIRDate" name="firDate"
                            value={advocateClientCaseData.firDate}
                            onChange={handleFieldChange} />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Police Station<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtPoliceStation"
                            maxLength={30}
                            name="policeStation"
                            placeholder="Police Station"
                            value={advocateClientCaseData.policeStation}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Row className="mb-1 hidden-controler ">
                        <Form.Control
                          className='mb-1'
                          style={{ visibility: 'hidden' }}
                          disabled
                          placeholder="Hidden Field"
                        />
                      </Row>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1 court-name-popup"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <span className="required-label">Court Name</span>:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtCourtCode"
                            name="courtCode"
                            value={advocateClientCaseData.courtCode}
                            onChange={handleFieldChange}
                            required
                          >
                            <option value="">Select Court Name</option>
                            {courtMasterList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(caseDetailError?.courtNameErr || {}).map(key => {
                            return (
                              <span key={key} className="error-message">
                                {caseDetailError.courtNameErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Court No.<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="courtNo"
                            maxLength={10}
                            name="courtNo"
                            placeholder="Court No"
                            value={advocateClientCaseData.courtNo}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Judge Name<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="judgeName"
                            maxLength={50}
                            name="judgeName"
                            placeholder="Judge Name"
                            value={advocateClientCaseData.judgeName}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <span className="required-label">Country</span>:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtCountry"
                            name="countryCode"
                            value={advocateClientCaseData.countryCode}
                            onChange={handleFieldChange}
                            required
                          >
                            <option value="">Select Country</option>
                            {countryList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(caseDetailError?.countryErr).map(key => {
                            return (
                              <span className="error-message">
                                {caseDetailError?.countryErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <span className="required-label">State</span>:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtState"
                            name="stateCode"
                            value={advocateClientCaseData.stateCode}
                            onChange={handleFieldChange}
                          >
                            <option value="">Select State</option>
                            {stateList.map((option, index) => (
                              <option key={index} value={option.value}>
                                {option.key}
                              </option>
                            ))}
                          </Form.Select>
                          {Object.keys(caseDetailError?.stateErr || {}).map(key => {
                            return (
                              <span key={key} className="error-message">
                                {caseDetailError.stateErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col className="third-case-popup" sm={4} md={4}>
                      <Row className="mb-1 mt-2 hidden-controler ">
                        <Form.Control
                          className='mb-1'
                          style={{ visibility: 'hidden' }}
                          disabled
                          placeholder="Hidden Field"
                        />
                      </Row>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1 fir-no-popup"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <span className="required-label">Register Date</span>:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control type='date' id="txtRegisterDate" name="caseRegisterDate"
                            value={advocateClientCaseData.caseRegisterDate}
                            onChange={handleFieldChange}
                            required
                          />
                          {Object.keys(caseDetailError?.registerDateErr || {}).map((key) => {
                            return <span key={key} className="error-message">{caseDetailError.registerDateErr[key]}</span>
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Filing No.<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtFilingNo"
                            name="filingNo"
                            maxLength={30}
                            onChange={handleFieldChange}
                            value={advocateClientCaseData?.filingNo}
                            placeholder="Filing No"
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Filing Date<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control type='date' id="txtFilingDate" name="filingDate"
                            max={new Date().toISOString().split("T")[0]}
                            value={advocateClientCaseData?.filingDate}
                            onChange={handleFieldChange}
                            required
                          />
                        </Col>
                      </Form.Group>
                      <Row className="mb-1 hidden-controler ">
                        <Form.Control
                          className='mb-1'
                          style={{ visibility: 'hidden' }}
                          disabled
                          placeholder="Hidden Field"
                        />
                      </Row>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1 file-no-popup"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          File No.<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtFileNo"
                            name="fileNo"
                            maxLength={20}
                            placeholder="File No"
                            value={advocateClientCaseData.fileNo}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Room No.<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtRoomNo"
                            maxLength={5}
                            name="roomNo"
                            placeholder="Room No"
                            value={advocateClientCaseData.roomNo}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Almirah No.<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtAlmirahNo"
                            maxLength={5}
                            name="almirah"
                            placeholder="Almirah No"
                            value={advocateClientCaseData.almirah}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-1"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Rack No.<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            id="txtRackNo"
                            maxLength={50}
                            name="rack"
                            placeholder="Rack No"
                            value={advocateClientCaseData.rack}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col className="forth-case-popup" sm={4} md={4}>
                      <Row className="mb-1 mt-2 hidden-controler ">
                        <Form.Control
                          className='mb-1'
                          style={{ visibility: 'hidden' }}
                          disabled
                          placeholder="Hidden Field"
                        />
                      </Row>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2 fir-no-popup"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon ">
                          <span className="required-label">Purpose</span>:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtPurpose"
                            name="purpose"
                            value={advocateClientCaseData.purpose}
                            onChange={handleFieldChange}
                          >
                            <option value="">Select </option>
                            <option value="Admission">Admission</option>
                            <option value="Appearance">Appearance </option>
                            <option value="Argument">Argument</option>
                            <option value="Charge/Issue">Charge/Issue </option>
                            <option value="Evidence">Evidence </option>
                            <option value="Misc">Misc</option>
                            <option value="Rejoinder">Rejoinder </option>
                            <option value="Reply">Reply </option>
                          </Form.Select>
                          {Object.keys(caseDetailError?.purposeErr || {}).map((key) => {
                            return <span key={key} className="error-message">{caseDetailError.purposeErr[key]}</span>
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2"
                        controlId="formHorizontalEmail"
                      >

                        <Form.Label column sm={4} className="label-with-colon">
                          <span className="required-label">Client</span>:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtParty"
                            name="party"
                            value={advocateClientCaseData.party}
                            onChange={handleFieldChange}>
                            <option value="">Select </option>
                            <option value="Accused">Accused </option>
                            <option value="Offender">Offender</option>
                            <option value="Defender">Defender </option>
                            <option value="Petitioner">Petitioner </option>
                            <option value="Plaintiff">Plaintiff </option>
                            <option value="Respondents">Respondents </option>
                          </Form.Select>
                          {Object.keys(caseDetailError?.clientErr || {}).map((key) => {
                            return <span key={key} className="error-message">{caseDetailError.clientErr[key]}</span>
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Case Status<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            id="txtCaseStatus"
                            name="caseStatus"
                            value={advocateClientCaseData.caseStatus}
                            onChange={handleFieldChange}
                          >
                            <option value="ONGOING" selected>ONGOING </option>
                            <option value="WON">WON </option>
                            <option value="LOST">LOST </option>
                            <option value="CLOSED">CLOSED </option>
                            <option value="DISPOSED">DISPOSED </option>
                          </Form.Select>
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          <span className="required-label text-nowrap">Next Hearing Date</span>:
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control type='date' id="txtNextHearingDate" name="nextHearingDate"
                            value={advocateClientCaseData.nextHearingDate}
                            onChange={handleFieldChange}
                            required
                          />
                          {Object.keys(caseDetailError?.nextHearingDateErr || {}).map((key) => {
                            return <span key={key} className="error-message">{caseDetailError.nextHearingDateErr[key]}</span>
                          })}
                        </Col>
                      </Form.Group>
                      <Row className="mb-0 hidden-controler ">

                        <Form.Control
                          className='mb-0'
                          style={{ visibility: 'hidden' }}
                          disabled
                          placeholder="Hidden Field"
                        />

                      </Row>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2 advocate-name-popup"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon text-nowrap">
                          Advocate  Name<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtAttendantAdvocate"
                            name="attendantAdvocateName"
                            maxLength={50}
                            placeholder="Advocate Name"
                            value={advocateClientCaseData.attendantAdvocateName}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Opp Adv Name<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtOppAdvName"
                            maxLength={50}
                            name="oppAdvName"
                            placeholder="Opp Adv Name"
                            value={advocateClientCaseData.oppAdvName}
                            onChange={handleFieldChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon">
                          Opp Adv Mob<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtOppAdvMob"
                            name="oppAdvMob"
                            maxLength={10}
                            placeholder="Opp Adv Mob"
                            value={advocateClientCaseData.oppAdvMob}
                            onChange={handleFieldChange}
                          />
                          {Object.keys(caseDetailError?.addvocateMobileNoErr || {}).map(key => {
                            return (
                              <span key={key} className="error-message">
                                {caseDetailError.addvocateMobileNoErr[key]}
                              </span>
                            );
                          })}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-0 ms-2"
                        controlId="formHorizontalEmail"
                      >
                        <Form.Label column sm={4} className="label-with-colon text-nowrap">
                          Consulting Fees<span>:</span>
                        </Form.Label>
                        <Col sm={8}>
                          <EnlargableTextbox
                            id="txtConsultingFees"
                            name="consultingFees"
                            value={advocateClientCaseData.consultingFees}
                            onChange={handleFieldChange}
                            placeholder="0.00"
                            onKeyPress={(e) => {
                              const key = String.fromCharCode(e.charCode);
                              const currentValue = e.target.value;
                              if (key === '.' && currentValue.includes('.')) {
                                e.preventDefault();
                              }
                              const regex = /^[0-9\.]+$/;
                              if (!regex.test(key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </FalconComponentCard.Body>
              </FalconComponentCard>
            </Col>
          </Row>

        </Form>
      }
    </>
  );
};

export default AdvocateClientCaseDetail;